export function isWixHttpError(exception) {
    // https://github.com/wix-private/metro/blob/2c81a9514e23b85ddca60f8bc8ae9a33c597299d/packages/http-client/src/http-client.ts#L34
    return exception.isWixHttpError === true;
}
//# sourceMappingURL=isWixHttpError.js.map